
import XButton from 'vux/src/components/x-button/index.vue'

import {
PageContainer,
PageHeader,
PageContent,
PageFooter,
} from '@/common/components/index'
import { mapState } from 'vuex'

import {service} from '@/common/index'
import nativeApi from '@/common/tool/sdk2/nativeApi'
import { setTimeout } from 'timers';




export default {
data () {
return {

}
},
components: {
PageContainer,
PageHeader,
PageContent,
PageFooter,
XButton,
},
computed: {
...mapState({
userInfo: state => state.user.userInfo,
guideInfo: state => state.user.guideInfo,
shopInfo: state => state.user.shopInfo,
orgInfo: state => state.user.orgInfo,
deviceInfo: state => state.user.deviceInfo,
custom: state => state.custom,
}),
},
created(){
nativeApi.initRnRunH5Function({










TestRnRunH5Function:(data)=>{
return new Promise((resolve, reject) => {
this.$vux.toast.text("h5函数已被激活")
setTimeout(()=>{
resolve({testValue: true})
},2000)
})
}

})
},
methods: {
testCustomApi(){
nativeApi.customApi.addApi('testCustomApi')
nativeApi.customApi.runApi(
'testCustomApi',
{a:1,b:2},
(data)=>{
setTimeout(()=>{
alert("H5 接受参数："+JSON.stringify(data))
},500)
}
)
},
GetGps(){
nativeApi.nativeFN.GetGps((data)=>{
setTimeout(()=>{
alert(JSON.stringify(data))
},500)
})
},
RNGoBack(){
nativeApi.nativeFN.RNGoBack()
},
RNConsole(){
nativeApi.nativeFN.RNConsole(this.userInfo)
},
showPhoneMsg(){
alert(JSON.stringify(this.deviceInfo))
},
TakePhoto(){
nativeApi.nativeFN.TakePhoto((data)=>{
setTimeout(()=>{
alert(JSON.stringify(data))
},500)
})
},
UploadPhoto(){
nativeApi.nativeFN.UploadPhoto((data)=>{
setTimeout(()=>{
alert(JSON.stringify(data))
},500)
})
},


barcodeScannerStore(){
nativeApi.nativeFN.barcodeScannerStore({codePrefix:111,pointData:222},(data)=>{
this.$vux.toast.text(data)
})
},
isRetrial(){
nativeApi.nativeFN.FlowRetrial()
},
FlowStart(){
nativeApi.nativeFN.FlowStart()
},
rnRouter(){
nativeApi.nativeFN.rnRouter({
url:'messageList',
props:{}
})
},
rnApproval(flag){
nativeApi.nativeFN.rnRouterApproval({
processKey:'OA_SEAL_TASK',
saveFlag: flag
})
},
closeWindow(){
nativeApi.nativeFN.closeWindow()
},
call(){
nativeApi.nativeFN.phoneCall('400123123')
},
wechat(){
nativeApi.nativeFN.openWechat()
},
showUserMsg(type){
alert(JSON.stringify(this[type]))
},
showUserMsgKey(type){
alert(JSON.stringify(this[type].certificate))
},
showOrgId(){
alert(JSON.stringify(this.orgInfo.orgId))
},
gps(){
nativeApi.nativeFN.geolocation((data)=>{
this.$vux.toast.text(data)
})
},
barcodeScanner(){
nativeApi.nativeFN.barcodeScanner((data)=>{
this.$vux.toast.text(data)
})
},
barcodeScannerS(){
nativeApi.nativeFN.barcodeScannerS((data)=>{
this.$vux.toast.text(data)
})
},
logout(){
nativeApi.nativeFN.logout()
},
testStore(){
alert(this.custom.testValue)
this.$store.commit('CUSTOM_TEST')
alert(this.custom.testValue)
},
OpenWechat(){
nativeApi.nativeFN.OpenWechat()
}
},
watch:{
},
mounted(){

},
}




// WEBPACK FOOTER //
// ./src/page/demo/RNDemoV2.vue